export default "__VITE_PUBLIC_ASSET__542f1b9b__"